import { Toaster } from '@creditsights/styleguide-web';
import { useEffect } from 'react';
import { useRecoilState } from 'recoil';
import { ToasterConfig, toasterState } from '../../atoms/toaster.atom';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function ToasterContainer() {
  const [config, setConfig] = useRecoilState<ToasterConfig>(toasterState);

  useEffect(() => {
    if (config.text) {
      setTimeout(() => close(), config.timeout || 5000);
    }
  }, [config]);

  const close = () => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    setConfig((config) => ({
      text: '',
      bold: false,
    }));
  };

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{config?.text && <Toaster textContent={<span>{config.text}</span>} onClose={close} mode={config.mode} />}</>;
}

export default ToasterContainer;
